import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import get from 'lodash.get';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { LabeledInfo } from 'ui-components/components/labeled-info';
import { noop } from 'ui-components/default-props/noop';
import OrderItems from '../../../../components/item-list-read-only';
import ShipTo from '../../../../components/ship-to';
import { ReturnShipmentPropType } from '../../../../prop-types/return-shipment';
import { emptyObject } from 'ui-components/default-props/empty';

import { ActiveReturnLabel } from './active-return-label';
import style from './return-details-modal-content.module.less';

const messages = defineMessages({
  orderNumber: {
    description: 'returnDetails.content.orderNumber',
    defaultMessage: 'Order Number',
    id: '21rbCw',
  },
});

export const ReturnDetailsBody = ({
  returnShipment = emptyObject,
  // The Prop (shipTo) given to this component represents the warehouse destination for the return shipment.
  shipTo,
  packageType,
  validateAddress = noop,
  userHasOrderManagementRole = false,
}) => {
  const items = get(returnShipment, 'items') || [];
  // Some naming gets confusing here. The shipTo in the return configuration is the customer's address.
  // Which appears as "Ship From" in the return details modal.
  const shipFrom = get(returnShipment, 'returnConfiguration.shipTo');
  const orderNumber = get(returnShipment, 'orderNumber');
  const { formatMessage } = useIntl();
  return (
    <div className={style['content-body']}>
      <div className={style['content-left-section']}>
        <div className={style['content-left-section-content']}>
          <div className={style['content-order-info']}>
            <div className={style['content-order-info-top']}>
              <div className={style['order-info-left-side']}>
                <div className={style['content-whole-line']}>
                  <LabeledInfo
                    className={classnames(style['order-number'], {
                      [style['has-order-management']]: userHasOrderManagementRole,
                    })}
                    label={formatMessage(messages.orderNumber)}
                    showMdash={!orderNumber}
                  >
                    {orderNumber}
                  </LabeledInfo>
                </div>
              </div>
              <div className={style['order-info-right-side']}>
                <ShipTo
                  className={style['ship-to-left-border']}
                  data={shipFrom}
                  hideAddressValidation
                  isReturn
                  validateAddress={validateAddress}
                />
              </div>
            </div>
            <div className={style['order-info-items']}>
              <div>
                <h4>
                  <FormattedMessage defaultMessage='Shipment Items' description='shipmentDetails.content.shipmentItemsTitle' id='c9qa3p' />
                </h4>
              </div>
              <OrderItems onItemHeaderClicked={noop} orderItems={items} />
            </div>
          </div>
        </div>
      </div>

      <div className={style['content-right-section']}>
        <div className={style['content-right-section-content']}>
          <ActiveReturnLabel packageType={packageType} returnShipment={returnShipment} shipTo={shipTo} />
        </div>
      </div>
    </div>
  );
};

ReturnDetailsBody.propTypes = {
  returnShipment: ReturnShipmentPropType,
  shipTo: PropTypes.string,
  packageType: PropTypes.string,
  validateAddress: PropTypes.func,
  userHasOrderManagementRole: PropTypes.bool,
};
